export enum ETipoEmissaoBoleto {
  Propria = 1,
  Terceiros = 2
}
